export enum EmailAction {
  CREATE = "CREATE",
  FORGET = "FORGET",
  PAYMENT = "PAYMENT",
}
